import { AutogenModelEdistatusProfileDisplay, AutogenRowEdistatusProfileDisplay } from "./autogen/AutogenModelEdistatusProfileDisplay";

export class ModelEdistatusProfileDisplay extends AutogenModelEdistatusProfileDisplay<RowEdistatusProfileDisplay> {
	constructor() {
		super(RowEdistatusProfileDisplay);
	}
}

export class RowEdistatusProfileDisplay extends AutogenRowEdistatusProfileDisplay {
}